import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class EventData {}

export class EmptyEventData implements EventData {}

@Injectable({
  providedIn: 'root'
})
export class EventBrokerService {

  private eventBusSubject = new BehaviorSubject<EventData>(new EmptyEventData());
  eventBus = this.eventBusSubject.asObservable();

  constructor() { }

  sendEvent(event: EventData): void {
    this.eventBusSubject.next(event);
  }
}
